import { EnvironmentDetail, PromiseUtils } from '@amzn/ihm-associate-tools-js-lib'
import { WakeButtonService } from '@services/voice/WakeButtonService'
import { CandyCaneWakeWordService } from '@services/voice/CandyCaneWakeWordService'

/**
 * Cross frame listener for wakeWord.
 *
 * Listens for wakeWord requests and forwards them to the wakeButtonService
 * or CandyCaneWakeWordService based on the environment.
 * Returns a promise from the service.
 *
 * @param {object} message - Object with the following structure:
 *  {
 *      data: {
 *          action: {string} - one of 'listen', 'warmup', 'cancel'
 *          parameters: {object} - object containing the parameters for the listen call
 *      }
 *  }
 *  @return {Promise} - Promise for the specified action.
 */
export async function wakeWordListener (message: any) {

    const action = message && message.data && message.data.action
    const params = message && message.data && message.data.parameters
    const implementation = EnvironmentDetail.isAndroid()
        ? CandyCaneWakeWordService
        : WakeButtonService

    switch (action) {
    case 'warmup':
        return implementation.warmup()
    case 'cancel':
        return implementation.cancel()
    case 'listen':
        return implementation.listen(params)
    }

    return PromiseUtils.newRejectedPromiseWithErrorMessage('Unsupported action: ' + action)
}
